export * from './SamuiMapWithBeaches';
